import {useMemo} from 'react'
import {useMsal} from '@azure/msal-react'

const ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  CUSTOMER_SUPPORT: 'CustomerSupport',
  DELIVERY_ADMIN: 'Admin',
  VIEWER: 'Viewer'
}

export const useRolePermissions = () => {
  const {accounts} = useMsal()

  const userRoles = useMemo(() => {
    return accounts[0]?.idTokenClaims?.roles || []
  }, [accounts])

  // checking specific permission
  const isSuperAdmin = () => {
    return userRoles.includes(ROLES.SUPER_ADMIN)
  }
  const isCustomerSupport = () => {
    return userRoles.includes(ROLES.CUSTOMER_SUPPORT)
  }
  const isDeliveryAdmin = () => {
    return (
      userRoles.includes(ROLES.DELIVERY_ADMIN) &&
      !userRoles.includes(ROLES.SUPER_ADMIN) &&
      !userRoles.includes(ROLES.CUSTOMER_SUPPORT)
    )
  }
  const isViewer = () => {
    return (
      userRoles.includes(ROLES.VIEWER) &&
      !userRoles.includes(ROLES.DELIVERY_ADMIN) &&
      !userRoles.includes(ROLES.SUPER_ADMIN) &&
      !userRoles.includes(ROLES.CUSTOMER_SUPPORT)
    )
  }

  return {
    userRoles,
    isSuperAdmin,
    isCustomerSupport,
    isDeliveryAdmin,
    isViewer,
    ROLES
  }
}
